export enum Status {
    AVAILABLE = 'AVAILABLE',
    UNAVAILABLE = 'UNAVAILABLE',
    NO_DATA = 'NO DATA'
}

export const getStatusByPercentual = (status: string): string => {
    if (status.toUpperCase() === Status.UNAVAILABLE) {
        return 'Unavailable'
    } else if (status.toUpperCase() === Status.NO_DATA) {
        return 'No Data'
    } else {
        return 'Available'
    }
}

// TODO: Verify the better way to pick this information on pipes and remove this resposability from here
export const getColorStatusByPercentual = (percentual: number, status: string): string => {
    if (status.toUpperCase() === Status.NO_DATA) {
        return '#D9D9D9'
    } else if (status.toUpperCase() === Status.UNAVAILABLE) {
        return '#172033'
    }
    if (percentual >= 90) {
        return '#01C292'
    } else if (percentual <= 89 && percentual >= 75) {
        return '#F5A300'
    } else if (percentual <= 74) {
        return '#D9534F'
    } else {
        return '#172033'
    }
}
